import { Strategy } from "./ancillary.js";
export function isGetterDescriptor(input) {
    return Boolean(input.get);
}
export function memoizeGetter(descriptor, propertyKey, strategy) {
    const originalFunction = descriptor.get;
    switch (strategy) {
        case Strategy.WEAKMAP: {
            const bindings = new WeakMap();
            descriptor.get = function () {
                let memoized = bindings.get(this);
                if (!memoized) {
                    memoized = originalFunction.apply(this);
                    bindings.set(this, memoized);
                }
                return memoized;
            };
            break;
        }
        case Strategy.REPLACE: {
            descriptor.get = function () {
                const value = originalFunction.apply(this);
                Object.defineProperty(this, propertyKey, {
                    configurable: false,
                    enumerable: false,
                    value: value,
                });
                return value;
            };
            break;
        }
        default:
            throw new Error(`Unsupported strategy: ${strategy}`);
    }
}
